import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoHouseTag } from '../../../../state/tags/definitions/geo/house';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoHouseTagItemProps {
  tag: IGeoHouseTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoHouseTagItem = (props: IGeoHouseTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
